import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthLogout } from '@x/ecommerce-shop/app/core/auth/state/auth.actions';
import { AuthState } from '@x/ecommerce-shop/app/core/auth/state/auth.state';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const isLoggedOutGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const store = inject(Store);
  const authService = inject(AuthService);

  return store.selectOnce(AuthState.loggedInUser).pipe(
    switchMap((user) => {
      if (!user) return of(true);

      return authService
        .openAuthDialog({
          canClose: true,
          heading: $localize`:@@Auth.AlreadyLoggedIn.Title:Already logged in`,
          message: $localize`:@@Auth.AlreadyLoggedIn.Note:You are already logged in, do you wish to log out?`,
          logout: true,
        })
        .pipe(
          switchMap((response) => {
            if (response === 'logout') {
              return store.dispatch(new AuthLogout()).pipe(map(() => true));
            }

            return of(false);
          }),
        );
    }),
  );
};
